import { ActionAny, createActions } from 'src/utils/createActions';
import { SelectedWidgetData } from 'src/react/selectedWidget/state/SelectedWidgetData';

export type SelectedWidgetDataActions =
    ActionAny<SelectedWidgetData | null, SelectedWidgetData | null>;
export const SELECTED_WIDGET_DATA_ACTIONS =
    createActions<SelectedWidgetData | null, SelectedWidgetData | null>('SELECTED_WIDGET_DATA');
